import { useRef } from 'react';

import { clipboard } from './clipboard';

export const useClipboard = <T extends Element>() => {
  const target = useRef<T>(null);

  const copy = async () => {
    if (!target.current) {
      return;
    }
    await clipboard.copy(target.current);
  };

  return {
    target,
    copy,
  };
};
